import React, { useEffect } from "react";
import { Col, Flex, Input, InputNumber, Row, Switch } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form, Button, Select } from "antd";
import RequiredLabel from "../../../../../common/required-label/RequiredLabel";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import {
  getAdminSubscriptionsAction,
  updateSubscriptionPlanAutoCreditByIdAction,
} from "../../../../../../redux/services/service-provider-subscriptions/serviceProviderSubscriptionsServices";
import { routes } from "../../../../../../constants";
import { baseRouteMakerForSuperAdmin } from "../../../../../../constants/routeConsts";
import styles from "./ReviewInfo.module.scss";
import { getSystemSettingsAction } from "../../../../../../redux/services/addon-and-sponsorship/addonAndSponsorshipServices";
import { updateKeyValueAction } from "../../../../../../redux/services/common/commonServices";
import { allowCharactersOnlyForDecimalNumbers } from "../../../../../../utils/appKeyStrokeLimitingUtils";

const ReviewConfig = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [selectListLoader, setSelectListLoader] = useState(false);
  /* loading dependencies */

  /* form dependencies */
  const [form] = Form.useForm();
  const { systemSettings } = useSelector((state) => state.addonAndSponsorship);
  const [status, setStatus] = useState(false);
  /* form dependencies */

  const handleGetTableData = () => {
    dispatch(getSystemSettingsAction(setLoading)).then((apiRes)=>{
      form.setFieldsValue({
        review_points: apiRes?.review_points || 0,
        review_points_active:apiRes?.review_points_active
      });
      setStatus(apiRes?.review_points_active)
    })
  }

  useEffect(()=>{
    handleGetTableData()
  },[])

  /* on status changed */
  const onStatusChanged = (value) => {
    setStatus(value)
  }
  /* on status changed */


  /* Form submit handler */
  const onSubmit = (values) => {
    let dataToBeSent = {
      review_points: Number(values?.review_points),
      review_points_active: values?.review_points_active
    };

    dispatch(updateKeyValueAction(dataToBeSent, setLoading)).then(()=>{
      handleGetTableData();
    })
  };
  /* Form submit handler */

  return (
    <div className={styles.reviewConfigContainer}>
      <Flex vertical gap="2rem">
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
          requiredMark={false}
          onFinish={onSubmit}
        >
          <Row gutter={[24, 24]}>
            <Col span={8}>
              <Form.Item
                label={
                  <RequiredLabel
                    text={t("reviewInfo.reviewPoints")}
                    required={true}
                  />
                }
                name="review_points"
                rules={[
                  {
                    required: true,
                    message: t(
                      "reviewInfo.pleaseEnterReviewPoints"
                    ),
                  },
                  {
                    validator: (_, value) => {
                      if (value && value < 1)
                        return Promise.reject(
                          `${t("reviewInfo.reviewPoints")} ${t(
                            "CommonUtils.shouldBeGreaterThan0"
                          )}`
                        );
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  type="number"
                  placeholder={t("reviewInfo.enterReviewPoints")}
                  onKeyDown={(e) => allowCharactersOnlyForDecimalNumbers(e)}
                />
              </Form.Item>
            </Col>

            <Col span={14}>
              <Form.Item
                name="review_points_active"
                label={
                  <RequiredLabel
                    text={t("reviewInfo.status")}
                    required={false}
                  />
                }
              >
                <Switch
                  checkedChildren={<CheckOutlined />}
                  unCheckedChildren={<CloseOutlined />}
                  checked={status}
                  onClick={(e) => onStatusChanged(e)}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[24, 24]}>
            <Col span={24} style={{ textAlign: "center" }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                disabled={loading}
              >
                {t("CommonUtils.submit")}
              </Button>
            </Col>
          </Row>
        </Form>
      </Flex>
    </div>
  );
};

export default ReviewConfig;
